import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["pathsToTitleMap"];
import { Select } from 'foundations-components/transitional/components/Select';
import { useLocation, useHistory } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
const TabsSelect = _ref => {
  let {
      pathsToTitleMap
    } = _ref,
    selectProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const location = useLocation();
  const history = useHistory();
  const options = Object.entries(pathsToTitleMap).map(([value, title]) => ({
    text: title,
    value
  }));
  const handleChange = evt => {
    history.replace(evt.target.value);
  };
  return /*#__PURE__*/_jsx(Select, Object.assign({
    defaultValue: location.pathname,
    maxInlineSize: "180px",
    onChange: handleChange,
    options: options,
    searchable: false
  }, selectProps));
};
export default TabsSelect;